import React, { useState } from "react";

const G = "#0077B5";

export default function WorkspaceEmptyState({ user, onCreateWorkspace }) {
  const [name, setName] = useState("");
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);

  const planLabel = user?.plan === "agency" ? "Agency" : "Team";

  const handleCreate = async () => {
    if (!name.trim()) {
      setError("Workspace name is required");
      return;
    }
    setError(null);
    setCreating(true);
    try {
      await onCreateWorkspace(name.trim());
    } catch (e) {
      setError(e.message || "Failed to create workspace");
      setCreating(false);
    }
  };

  return (
    <div style={{ maxWidth: 560, margin: "80px auto", padding: 32, textAlign: "center" }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>&#128101;</div>
      <h1 style={{
        fontSize: 28, fontWeight: 700, marginBottom: 12,
        fontFamily: "'Playfair Display',Georgia,serif",
      }}>
        Create your first workspace
      </h1>
      <p style={{
        fontSize: 16, color: "#555", marginBottom: 32, lineHeight: 1.5,
        fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif",
      }}>
        You're on the <strong>{planLabel}</strong> plan. Create a workspace to start collaborating with your team.
      </p>
      <input
        type="text"
        placeholder="Workspace name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleCreate()}
        disabled={creating}
        style={{
          width: "100%", padding: "12px 16px", fontSize: 16,
          border: "1px solid #ddd", borderRadius: 8, marginBottom: 12,
          boxSizing: "border-box",
          fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif",
        }}
      />
      {error && (
        <div style={{ color: "#B91C1C", fontSize: 14, marginBottom: 12 }}>{error}</div>
      )}
      <button
        onClick={handleCreate}
        disabled={creating || !name.trim()}
        style={{
          padding: "12px 24px", fontSize: 16, fontWeight: 600,
          backgroundColor: G, color: "white", border: "none", borderRadius: 8,
          cursor: creating || !name.trim() ? "not-allowed" : "pointer",
          opacity: creating || !name.trim() ? 0.6 : 1,
          fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif",
        }}
      >
        {creating ? "Creating..." : "Create workspace"}
      </button>
      <div style={{ marginTop: 32, fontSize: 13, color: "#888" }}>
        <a href="#/settings" style={{ color: G, textDecoration: "none" }}>
          Manage billing &rarr;
        </a>
      </div>
    </div>
  );
}
